import { cn } from '@/utils/tailwind';
import { ReactNode, useEffect, useRef } from 'react';
import { BottomSheet, BottomSheetRef } from 'react-spring-bottom-sheet';

interface BottomSheetContainerProps {
  open: boolean;
  children: ReactNode;
  onDismiss: () => void;
  containerClassName?: string;
}

const BottomSheetContainer = ({
  open,
  children,
  onDismiss,
  containerClassName,
}: BottomSheetContainerProps) => {
  const sheetRef = useRef<BottomSheetRef>(null);

  useEffect(() => {
    // 손잡이 DOM 요소 찾아서 숨기기
    if (open) {
      setTimeout(() => {
        const header = document.querySelector('[data-rsbs-header]');
        if (header) {
          (header as HTMLElement).style.display = 'none';
        }
      }, 0);
    }
  }, [open]);

  return (
    <BottomSheet
      ref={sheetRef}
      open={open}
      onDismiss={() => {
        setTimeout(() => onDismiss(), 100);
      }}
    >
      <div className={cn('px-[20px] pb-[40px] pt-[10px]', containerClassName)}>{children}</div>
    </BottomSheet>
  );
};

export default BottomSheetContainer;
